<template>
  <div class="TransferOrderDialog">
    <el-dialog
      title="提示"
      :visible.sync="visible"
      width="400px"
      :before-close="close">
      <div slot="title" class="transferOrder_title">
        <div class="title_name">转单</div>
        <div class="title_tips">
          <span class="el-icon-warning"></span>
          <span>确定转单后不可撤回</span>
        </div>
      </div>
      <div>
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="转单至：">
            <el-select class="form_select" v-model="form.receiveDeptId" placeholder="请选择">
              <el-option
                v-for="item in list"
                :key="item.deptId"
                :label="item.deptName"
                :value="item.deptId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { getDrugCenterList } from '@/api/hospital'
  import { transferOrder } from '@/api/pricingDetails'
  export default {
    name: 'TransferOrderDialog',
    data() {
      return {
        visible: false,
        submitLoading: false,
        list: [],
        form: {
          combinedNum: '',
          receiveDeptId: ''
        }
      }
    },
    methods: {
      open(combinedNum = '') {
        this.form.combinedNum = combinedNum
        getDrugCenterList().then(res => {
          if (res.code === 200) {
            this.list = res.data || []
            const defaultDept = this.list.find(v => v.deptCode === '5049')
            if (defaultDept) {
              this.form.receiveDeptId = defaultDept.deptId || ''
            }
          } else {
            this.$message.error(res.msg)
          }
        })
        this.visible = true
      },
      close() {
        this.visible = false
      },
      submit() {
        this.submitLoading = true
        transferOrder(this.form).then(res => {
          this.submitLoading = false
          if (res.code === 200) {
            this.$message.success('转单成功')
            this.close()
            this.$emit('success')
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .transferOrder_title{
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .title_name{
    font-weight: bold;
    font-size: 16px;
    color: #1F2329;
  }

  .title_tips{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0 0 0 8px;
    font-size: 14px;
    color: #FE8F1F;
  }

  .TransferOrderDialog /deep/ .el-dialog__body{
    padding-bottom: 0px;
  }

  .form_select{
    width: 100%;
  }
</style>
